// extracted by mini-css-extract-plugin
export var equalColumn = "_iq-0";